import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

// Auth
export const login = (username, password) => api.post("/auth/login", { username, password });
export const logout = () => api.post("/auth/logout");
export const getMe = () => api.get("/auth/me");
export const changePassword = (old_password, new_password) => api.post("/auth/change-password", { old_password, new_password });

// Users
export const getUsers = () => api.get("/users");
export const createUser = (data) => api.post("/users", data);
export const updateUser = (id, data) => api.put(`/users/${id}`, data);
export const deleteUser = (id) => api.delete(`/users/${id}`);

// Scheduler
export const getSchedule = () => api.get("/schedule");
export const saveSchedule = (data) => api.post("/schedule", data);
export const runScheduleNow = (params = {}) => api.post("/schedule/run-now", null, { params });

// App Settings
export const getAppSettings = () => api.get("/app-settings");
export const saveAppSettings = (data) => api.post("/app-settings", data);

// Fillout
export const getFilloutForms = (includeHidden = false) => api.get("/fillout/forms", { params: { include_hidden: includeHidden } });
export const hideFilloutForm = (form_id) => api.post(`/fillout/forms/${form_id}/hide`);
export const showFilloutForm = (form_id) => api.post(`/fillout/forms/${form_id}/show`);
export const purgeFilloutFormSubmissions = (form_id) => api.delete(`/fillout/forms/${form_id}/submissions`);
export const syncFilloutSubmissions = (form_id) => api.post("/fillout/sync", null, { params: form_id ? { form_id } : {} });
export const searchFilloutAlunni = (q) => api.get("/fillout/alunni-search", { params: { q } });
export const getFilloutVisibleFields = (form_id) => api.get(`/fillout/forms/${form_id}/visible-fields`);
export const saveFilloutVisibleFields = (form_id, fields) => api.post(`/fillout/forms/${form_id}/visible-fields`, { fields });
export const getFilloutSubmissions = (form_id, status) => api.get("/fillout/submissions", { params: { form_id, status } });
export const getFilloutSubmission = (form_id, submission_id) => api.get(`/fillout/submissions/${form_id}/${submission_id}`);
export const updateFilloutSubmission = (form_id, submission_id, data) => api.put(`/fillout/submissions/${form_id}/${submission_id}`, data);
export const deleteFilloutSubmission = (form_id, submission_id) => api.delete(`/fillout/submissions/${form_id}/${submission_id}`);
export const getFilloutEmailSettings = (form_id) => api.get(`/fillout/forms/${form_id}/email-settings`);
export const saveFilloutEmailSettings = (form_id, data) => api.post(`/fillout/forms/${form_id}/email-settings`, data);
export const sendFilloutConfirmation = (form_id, submission_id) => api.post(`/fillout/submissions/${form_id}/${submission_id}/send-email`);

// Stati di Cassa
export const getStatiCassaRiassunto = (data_da, data_a) => api.get("/stati-cassa/riassunto", { params: { data_da, data_a } });
// `data` è obbligatoria (giorno o data_da). Se `opts.data_a` è presente, è un range.
export const getStatiCassaGiorno = (data, anno, modalita, opts = {}) => {
  const params = { data, anno };
  if (modalita === "BONIFICO") params.bonifici_only = 1;
  else if (modalita === "POS_BON") {
    // data_pos viene passato in opts: query combinata Mod=2 (di data_pos) + bonifici (di data)
    params.bonifici_only = 1;
  } else if (modalita !== undefined && modalita !== null) params.modalita = modalita;
  return api.get("/stati-cassa/giorno", { params: { ...params, ...opts } });
};
export const exportStatiCassaGiorno = (data, modalita, opts = {}) => {
  const params = { data };
  if (modalita === "BONIFICO") params.bonifici_only = 1;
  else if (modalita === "POS_BON") params.bonifici_only = 1;
  else if (modalita !== undefined && modalita !== null) params.modalita = modalita;
  return api.get("/stati-cassa/giorno/export", { params: { ...params, ...opts }, responseType: "blob" });
};
export const listSpese = (params) => api.get("/stati-cassa/spese-list", { params });
export const getBancaMovimenti = (params) => api.get("/stati-cassa/banca", { params });
export const getBancaStats = () => api.get("/stati-cassa/banca/stats");
export const uploadBanca = (file, mode = "replace") => {
  const fd = new FormData();
  fd.append("file", file);
  return api.post(`/stati-cassa/banca/upload?mode=${encodeURIComponent(mode)}`, fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};
export const deleteBancaAll = () => api.delete("/stati-cassa/banca");
export const deleteBancaMovimento = (id) => api.delete(`/stati-cassa/banca/movimento/${encodeURIComponent(id)}`);

// Config
export const getConfig = () => api.get("/config");
export const saveConfig = (data) => api.post("/config", data);
export const testConfig = () => api.get("/config/test");

// Sync
export const syncAnagrafica = (anno) => api.post("/sync/anagrafica", { anno });
export const syncMovimenti = (data) => api.post("/sync/movimenti", data);

// Dashboard
export const getDashboardStats = (anno) => api.get("/dashboard/stats", { params: anno ? { anno } : {} });
export const getDashboardMatrix = (params) => api.get("/dashboard/matrix", { params });
export const getDashboardIncassatoReale = (params) => api.get("/dashboard/incassato-reale", { params });

// Anni e Filtri
export const getAnniDisponibili = () => api.get("/anni-disponibili");
export const getFiltriClassi = (anno) => api.get("/filtri-classi", { params: anno ? { anno } : {} });

// Alunni
export const getAlunni = (params) => api.get("/alunni", { params });
export const getAlunno = (cod, anno) => api.get(`/alunni/${cod}`, { params: anno ? { anno } : {} });
export const getAlunniCountsBySettore = (params) => api.get("/alunni/counts-by-settore", { params });
export const getAlunniCountsByCiclo = (params) => api.get("/alunni/counts-by-ciclo", { params });
export const getAlunniDashboardAddebiti = (params) => api.get("/alunni/dashboard-addebiti", { params });
export const getAlunniDashboardAddebitiSerie = (params) => api.get("/alunni/dashboard-addebiti-serie", { params });
export const getComunicatorOutboxByAlunno = (cod, params) => api.get(`/comunicator/outbox-by-alunno/${cod}`, { params });

// Genitori
export const getGenitori = (params) => api.get("/genitori", { params });
export const getGenitore = (cod, anno) => api.get(`/genitori/${cod}`, { params: anno ? { anno } : {} });

// Classi
export const getClassi = (anno) => api.get("/classi", { params: anno ? { anno } : {} });

// Movimenti
export const getMovimenti = (params) => api.get("/movimenti", { params });
export const getFiltriMovimenti = (anno) => api.get("/filtri-movimenti", { params: anno ? { anno } : {} });
export const setMovimentoMarcatura = (anno, num, payload) => api.put(`/movimenti/${anno}/${num}/marcatura`, payload);
export const runMarcatoreAuto = (anno) => api.post("/movimenti/marcatore/auto", null, { params: { anno } });

// Tabelle
export const getTabelleCausali = () => api.get("/tabelle/causali");
export const getTabelleModalita = () => api.get("/tabelle/modalita");
export const getTabelleSettori = () => api.get("/tabelle/settori");
export const getGruppiModalita = () => api.get("/tabelle/gruppi-modalita");
export const createGruppoModalita = (data) => api.post("/tabelle/gruppi-modalita", data);
export const updateGruppoModalita = (codice, data) => api.put(`/tabelle/gruppi-modalita/${codice}`, data);
export const deleteGruppoModalita = (codice) => api.delete(`/tabelle/gruppi-modalita/${codice}`);
export const getGruppiSettori = () => api.get("/tabelle/gruppi-settori");
export const createGruppoSettori = (data) => api.post("/tabelle/gruppi-settori", data);
export const updateGruppoSettori = (codice, data) => api.put(`/tabelle/gruppi-settori/${codice}`, data);
export const deleteGruppoSettori = (codice) => api.delete(`/tabelle/gruppi-settori/${codice}`);
export const getGruppiCausali = () => api.get("/tabelle/gruppi-causali");
export const createGruppoCausali = (data) => api.post("/tabelle/gruppi-causali", data);
export const updateGruppoCausali = (codice, data) => api.put(`/tabelle/gruppi-causali/${codice}`, data);
export const deleteGruppoCausali = (codice) => api.delete(`/tabelle/gruppi-causali/${codice}`);
export const getTabellePdc = () => api.get("/tabelle/pdc");
export const updatePdc = (conto, data) => api.put(`/tabelle/pdc/${conto}`, data);

// Elaborazioni
export const runElaborazioneGiorno = (data, anno) => api.post("/elaborazione/giorno", null, { params: { data, anno } });
export const getElaborazioneGiorno = (data, anno) => api.get("/elaborazione/giorno", { params: { data, anno } });
export const listElaborazioni = () => api.get("/elaborazioni");
export const deleteElaborazioneGiorno = (data, anno, tipo = "pdc") => api.delete("/elaborazione/giorno", { params: { data, anno, tipo } });
export const deleteAllElaborazioni = (tipo) => api.delete("/elaborazioni/all", tipo ? { params: { tipo } } : undefined);
export const runElaborazioneCassa = (data_da, data_a, bonifico_overrides = {}) =>
  api.post("/elaborazione/cassa", bonifico_overrides || {}, { params: { data_da, data_a } });
export const getElaborazioneGiornoMovimenti = (data, anno, conto) => api.get("/elaborazione/giorno/movimenti", { params: { data, anno, conto } });
export const getElaborazioneCassaGiorno = (data) => api.get("/elaborazione/cassa/giorno", { params: { data } });
export const runElaborazionePeriodo = (data_da, data_a, anno) => api.post("/elaborazione/periodo", null, { params: { data_da, data_a, anno } });
export const loadElaborazionePeriodo = (data_da, data_a, anno) => api.get("/elaborazione/periodo/load", { params: { data_da, data_a, anno } });
export const listPeriodiAggregati = () => api.get("/elaborazioni/periodi-aggregati");
export const getPdcPivot = (data_da, data_a, anno, only_movimentati = true) =>
  api.get("/elaborazione/pdc-pivot", { params: { data_da, data_a, anno, only_movimentati } });

export default api;
